import { useSelector } from 'react-redux';
import UserService from "../services/UserService";

const RenderOnAnonymous = ({ children }) => {
    const realm = useSelector((state) => state.theRealm);
    UserService.setRealm(realm)
    return (
        (!UserService.isLoggedIn()) ? children : null
    )
}

export default RenderOnAnonymous;
